import { useLocation } from '@reach/router';
import pushInDataLayer from '../pushInDataLayer';
import { type PersonalizationAttributes } from './component-personalization.schema';
import { useEffect } from 'react';

interface UseSendPersonalizationAnalyticsArgs {
  hasAbTest: boolean;
  winningCampaigns: Array<string>;
  attributes?: PersonalizationAttributes;
}

export const useSendPersonalizationAnalytics = ({
  hasAbTest,
  winningCampaigns,
  attributes,
}: UseSendPersonalizationAnalyticsArgs) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    if (hasAbTest) {
      return;
    }

    if (typeof attributes === 'undefined') {
      return;
    }

    const companyDetails = {
      company_match: attributes.company.company_match,
      additional_comment: attributes.company.additional_comment,
      companyId: attributes.company.companyId,
      domain: attributes.company.domain,
      country_iso_code: attributes.company.country_iso_code,
      phone: attributes.company.phone,
      employee_range: attributes.company.employee_range,
      revenue_range: attributes.company.revenue_range,
      employee_count: attributes.company.employee_count,
      annual_revenue: attributes.company.annual_revenue,
      is_blacklisted: attributes.company.is_blacklisted,
      industry_v2: attributes.company.industry_v2,
      scores: attributes.scores,
      confidence: attributes.confidence,
    };

    winningCampaigns.forEach((campaignId) => {
      pushInDataLayer({
        event: 'content-personalization',
        contentPersonalizationValue: {
          unique_id: campaignId,
          page_path: pathname,
          companyDetails,
        },
      });
    });
  }, [attributes, hasAbTest, pathname, winningCampaigns]);
};
